import { render, staticRenderFns } from "./PatientHospital.vue?vue&type=template&id=106785dc&scoped=true"
import script from "./PatientHospital.vue?vue&type=script&lang=js"
export * from "./PatientHospital.vue?vue&type=script&lang=js"
import style0 from "./PatientHospital.vue?vue&type=style&index=0&id=106785dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106785dc",
  null
  
)

export default component.exports